import { BlocksRenderer } from '@strapi/blocks-react-renderer'

import { cld } from '../../../services/CloudinaryService'
import { GallerySlider } from '../../reusable/GallerySlider'
import styles from './Page.module.scss'
import { IPageProps } from './Page.types'

export const Page = ({ data }: IPageProps) => {
  const images = data.gallery?.map((image) => cld.image(image.provider_metadata.public_id).toURL())

  return (
    <div className={styles.pageContentWrapper}>
      <h2 className={styles.pageTitle}>{data.header}</h2>
      <BlocksRenderer
        content={data.content}
        blocks={{
          image: ({ image }) => (
            <img
              className={styles.contentImage}
              src={image.url}
              alt={image.alternativeText || image.name}
              width={image.width}
              height={image.height}
            />
          ),
        }}
      />
      {!!images?.length && <GallerySlider images={images} />}
    </div>
  )
}
